import cx from 'classnames';
import { Form, FormControl, Image } from 'react-bootstrap';
import { icons } from '../assets';
import { CloseIcon } from '../components/icons/CloseIcon';
import CloseCircleIcon from '../components/icons/closeCircleIcon';
import CircularProgress from './CircularProgress';
const { SearchBarIcon } = icons;

export default function SearchInput({
  loading = false,
  onSubmit,
  value,
  placeholder,
  onChange,
  onFocus,
  className,
  inputClassName,
  onClear,
  disabled = false,
  onKeyDown,
}) {
  function handleSearchQuery(e) {
    e.preventDefault();
    onSubmit?.(e);
  }

  const customClearButton = Boolean(onClear);
  const inputType = customClearButton ? 'text' : 'search';

  return (
    <Form className={cx(className, 'd-block search-form')} onSubmit={handleSearchQuery}>
      <Form.Group className="search-form-group">
        <Form.Label className="search-icon" style={loading ? { top: 16 } : {}}>
          {loading ? <CircularProgress size={16} thickness={2} /> : <SearchBarIcon />}
        </Form.Label>
        <FormControl
          type={inputType}
          className={cx(
            inputClassName,
            'search-form-input',
            customClearButton && 'search-form-input-custom-close'
          )}
          value={value}
          placeholder={placeholder || 'Search'}
          onChange={onChange}
          onFocus={onFocus}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
        {customClearButton && value && (
          <CloseCircleIcon className="search-form-clear-icon" onClick={onClear} />
        )}
      </Form.Group>
    </Form>
  );
}
